/* @flow */
import React from "react";

import {
  VisibleIcon,
  HiddenIcon
} from "./Icons";

type Props = {
  value: boolean,
  onClick: Function
};

export default (props: Props) => (
  <div {...props} onClick={() => props.onClick(!props.value)}>
    {props.value
      ? <VisibleIcon />
      : <HiddenIcon />}
  </div>
);


// WEBPACK FOOTER //
// ./src/components/Toolbar/HideTool.js